var React = require('react');

function Lt (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#6da544","d":"M0 167l253.8-19.3L512 167v178l-254.9 32.3L0 345z","key":0}),React.createElement("path",{"fill":"#ffda44","d":"M0 0h512v167H0z","key":1}),React.createElement("path",{"fill":"#d80027","d":"M0 345h512v167H0z","key":2})])]);
}

Lt.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Lt;

Lt.default = Lt;
